import React from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { HtmlDiv } from '../../../../utils/types'
import Layout from '../../Layout/Layout'
import Banner from './Banner/Banner'
import EightBitEnv from './EightBitEnv/EightBitEnv'
import Wave from '../../../Core/Layout/Wave/Wave'
import useApp from '../../../AppContextProvider/hooks/useApp'

const OpenSourcePage = ({ className, ...rest }: OpenSourcePageProps) => {
  const { theme } = useApp()

  return (
    <Layout
      className={`${className}`}
      {...rest}
      seoTitle="Open Source"
      seoDescription="Open source projects by the Dev Simulator development team"
    >
      <Banner className="bg-primary-accent " />
      <Wave
        className="bg-primary-accent -mb-20"
        fill={theme.background.colors.base}
        height={10}
        numWaves={2}
      />
      <EightBitEnv className="mb-24" />
    </Layout>
  )
}

export interface OpenSourcePageProps extends HtmlDiv {}

export default styled(observer(OpenSourcePage))``
